var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v(" Forcefully Lost Dispose Report")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Hub Zone :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "newhubs",
      "options": _vm.newhublist,
      "placeholder": "Enter Zone",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": function($event) {
        _vm.callHub(_vm.newhubs)
      }
    },
    model: {
      value: (_vm.newhubs),
      callback: function($$v) {
        _vm.newhubs = $$v
      },
      expression: "newhubs"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Hub/SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "hub",
      "options": _vm.hublist,
      "placeholder": "Enter hub",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.hub),
      callback: function($$v) {
        _vm.hub = $$v
      },
      expression: "hub"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hub')),
      expression: "errors.has('hub')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("hub is required. ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" AWB Number :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-size": "13px"
    }
  }, [_vm._v("\n                  (Note: Use Comma(,) for Multiple AWB Numbers) ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "AWB",
      "name": "awbnumber",
      "type": "text"
    },
    model: {
      value: (_vm.awbnumber),
      callback: function($$v) {
        _vm.awbnumber = $$v
      },
      expression: "awbnumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "AWB"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB')),
      expression: "errors.has('AWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("AWB Number is required. ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Octroi MRP :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operator),
      expression: "operator"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('operator')
    },
    attrs: {
      "name": "operator",
      "id": "operator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(">")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("=")])]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal:2'),
      expression: "'decimal:2'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('detended_days_octroi_MRP')
    },
    attrs: {
      "id": "octroi_MRP",
      "disabled": _vm.checkDisabled,
      "name": "octroi_MRP",
      "placeholder": "Enter Amount",
      "type": "text"
    },
    model: {
      value: (_vm.octroi_MRP),
      callback: function($$v) {
        _vm.octroi_MRP = $$v
      },
      expression: "octroi_MRP"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('octroi_MRP')),
      expression: "errors.has('octroi_MRP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Shipment Value is required & Enter only number. ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Status :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "Status",
      "options": _vm.StatusList,
      "placeholder": "Select  Status",
      "label": "label",
      "track-by": "label",
      "disabled": ""
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Verification Status :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "vStatus",
      "disabled": "",
      "options": _vm.vStatusList,
      "placeholder": "Select Verification Status",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.vStatus),
      callback: function($$v) {
        _vm.vStatus = $$v
      },
      expression: "vStatus"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("From Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "fromdate",
      "name": "fromdate",
      "type": "date"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("To Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "todate",
      "name": "todate",
      "type": "date"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Detented Days From :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('detended_days_from')
    },
    attrs: {
      "type": "text",
      "name": "detended_days_from",
      "id": "detended_days_from"
    },
    model: {
      value: (_vm.detended_days_from),
      callback: function($$v) {
        _vm.detended_days_from = $$v
      },
      expression: "detended_days_from"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('detended_days_from')),
      expression: "errors.has('detended_days_from')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter only Numbers.\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Detented Days To :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('detended_days_to')
    },
    attrs: {
      "type": "text",
      "name": "detended_days_to",
      "id": "detended_days_to"
    },
    model: {
      value: (_vm.detended_days_to),
      callback: function($$v) {
        _vm.detended_days_to = $$v
      },
      expression: "detended_days_to"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('detended_days_to')),
      expression: "errors.has('detended_days_to')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter only Numbers.\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.searchData(0)
      }
    }
  }, [_vm._v(" Search "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.ExportDisableds
    },
    on: {
      "click": function($event) {
        _vm.exportfileCSV()
      }
    }
  }, [_vm._v("Export "), _c('i', {
    staticClass: "fa fa-download"
  })])])])])])], 1), _vm._v(" "), (_vm.isLoading1) ? _c('div', {
    staticClass: "col-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.show2,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#000080"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Shipment Details "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("(Total Records :" + _vm._s(_vm.totalcount) + ")")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_vm._m(0), _vm._v(" "), (_vm.editshowtable) ? _c('tbody', [(_vm.totalcount == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "colspan": "31",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listUserData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.netvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.regionname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.finaldestinationname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddate ? new Date(data.createddate).toLocaleDateString() : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.loggeddescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.verifieddate ? new Date(data.verifieddate).toLocaleDateString() : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.verifieddescription))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Statusname))]), _vm._v(" "), _c('td', [_vm._v("Dispose At UCG/SVC")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ordertype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.phyweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.volweight))]), _vm._v(" "), (_vm.abc == '' || _vm.abc !== data.shippingid) ? _c('td', [_c('b-link', {
      staticClass: "btn btn-sm btn-info",
      on: {
        "click": function($event) {
          _vm.ImageView(data.shippingid, data.status)
        }
      }
    }, [_c('i', {
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("View")])], 1) : (_vm.abc !== '' || _vm.abc == data.shippingid) ? _c('td', [_vm._l((_vm.List), function(d) {
      return _c('div', [_c('b-link', {
        on: {
          "click": function($event) {
            _vm.downloadImage(d.Key)
          }
        }
      }, [_c('i', {
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("Image")]), _vm._v(" "), _c('b-link', {
        attrs: {
          ":href": _vm.link + d.Key
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true"
        }
      })])], 1)
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "13px"
      }
    }, [_vm._v("\n\n                " + _vm._s(_vm.errormsg) + "\n                ")])], 2) : _vm._e()])
  })], 2) : _vm._e()])]), _c('br'), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF0000"
    }
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "active": _vm.show1,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#00FFFF"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.imgData,
      "download": ""
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeImage()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgData,
      "alt": "loading..."
    }
  })], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OctroiMRP")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Region")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current HubName")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin HubName")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination HubName")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DEPS Marked Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DEPS Marked Desc")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DEPS Verified Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DEPS Verified Desc")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Service (Coloader/Vendor)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Order Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Physical Weight")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Volumetric Weight")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a67d962","hasScoped":true}!./src/views/components/ForcefullyLostDisposeReport/ForcefullyLostDisposeReport.component.html
// module id = 511
// module chunks = 1